import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import { policies } from "../policies";
import { STORE_CONFIG } from "../config/storeConfig";

function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-column">
          <h4>Explore</h4>
          <ul><li><Link to="/shop" onClick={toTop}>Shop</Link></li><li><Link to="/about" onClick={toTop}>Our story</Link></li><li><Link to="/contact" onClick={toTop}>Contact</Link></li><li><Link to="/policies/faq" onClick={toTop}>FAQ</Link></li></ul>
        </div>
        <div className="footer-column footer-policies">
          <h4>Policies</h4>
          <ul>{policies.filter((policy) => policy.slug !== "faq").map((policy) => <li key={policy.slug}><Link to={`/policies/${policy.slug}`} onClick={toTop}>{policy.title}</Link></li>)}</ul>
        </div>
        <div className="footer-column">
          <h4>{STORE_CONFIG.brand}</h4>
          <div className="contact-info">
            <p>Operating region: {STORE_CONFIG.operatingRegion}</p>
            <p>Currency: {STORE_CONFIG.currency}</p>
            <p>Time zone: {STORE_CONFIG.timezone}</p>
            <p><a href={`mailto:${STORE_CONFIG.supportEmail}`}>{STORE_CONFIG.supportEmail}</a></p>
          </div>
          <div className="payment-supported" aria-label="Supported payment method">
            <span className="card-symbol" aria-hidden="true"><i /><i /></span>
            <span>Hosted card payment</span>
          </div>
        </div>
      </div>
      <div className="footer-bottom"><p className="copyright">© {new Date().getFullYear()} {STORE_CONFIG.brand}. {STORE_CONFIG.operatingRegion}.</p><p>Prices and checkout totals are shown in {STORE_CONFIG.currency}.</p></div>
    </footer>
  );
}

export default Footer;
